var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15.338 3.462a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4M10 13.334a3.334 3.334 0 1 1 .002-6.668A3.334 3.334 0 0 1 10 13.334m0-8.469a5.135 5.135 0 1 0 0 10.27 5.135 5.135 0 0 0 0-10.27m8.141 9.176c-.045.975-.208 1.504-.345 1.857-.182.467-.398.8-.748 1.15-.35.35-.683.567-1.15.747-.352.138-.882.3-1.857.345-1.054.048-1.37.059-4.041.059-2.67 0-2.986-.011-4.04-.059-.976-.045-1.505-.207-1.857-.345-.467-.18-.8-.397-1.15-.747a3.092 3.092 0 0 1-.748-1.15c-.137-.353-.3-.882-.345-1.857-.047-1.054-.058-1.371-.058-4.04 0-2.671.011-2.987.058-4.041.045-.976.208-1.505.345-1.857.181-.468.398-.801.748-1.15.35-.35.683-.567 1.15-.748.352-.138.881-.3 1.857-.345 1.054-.048 1.37-.058 4.04-.058 2.671 0 2.987.01 4.041.058.975.045 1.505.207 1.857.345.467.181.8.398 1.15.748.35.349.566.682.748 1.15.137.352.3.881.345 1.857.048 1.054.057 1.37.057 4.041 0 2.669-.009 2.986-.057 4.04m1.8-8.163c-.049-1.065-.218-1.792-.465-2.428a4.896 4.896 0 0 0-1.154-1.771A4.913 4.913 0 0 0 16.551.525c-.637-.247-1.363-.417-2.428-.464C13.057.012 12.716 0 10 0 7.285 0 6.944.012 5.878.061 4.813.108 4.086.278 3.45.525a4.905 4.905 0 0 0-1.771 1.154A4.896 4.896 0 0 0 .525 3.45C.278 4.086.109 4.813.061 5.878.012 6.943 0 7.285 0 10.001c0 2.714.012 3.056.061 4.122.048 1.064.217 1.792.464 2.427a4.908 4.908 0 0 0 1.154 1.772 4.902 4.902 0 0 0 1.771 1.153c.636.247 1.363.417 2.428.465 1.066.049 1.407.061 4.122.061 2.716 0 3.057-.012 4.123-.061 1.065-.048 1.791-.218 2.428-.465a4.91 4.91 0 0 0 1.771-1.153 4.908 4.908 0 0 0 1.154-1.772c.247-.635.416-1.363.465-2.427.047-1.066.059-1.408.059-4.122 0-2.716-.012-3.058-.059-4.123"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FEFEFE",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#40423F",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7a2f306a1cda59037b89f935d5e09663.svg";
export { ForwardRef as ReactComponent };